export const server = "PLG";
export const serverUrl = "https://services.plg1.cwsuite.com/retail/graphql";
export const CWCoreServicesUrl = "https://services.plg1.cwsuite.com/core/graphql";
export const edcUrl = "http://localhost:80/innoweb/api/MSwipe";
export const innovitiPaymentCodes = {
  Card: 0,
  GPay: 86,
  Sodexo: 90,
  UPI: 86,
};
